import { apiClient } from "../config/netConfig";

export interface BuildComponentAnalysisPromptRequest {
  serviceName?: string;
  pageId?: string;
  componentType: string;
  scenario?: string;
  locale?: string;
  storeName: string;
  componentLabel: string;
  timeDirection?: string;
  dataPackage: unknown;
  dateRange?: string;
}

export async function buildComponentAnalysisPrompt(
  payload: BuildComponentAnalysisPromptRequest,
): Promise<{ code: number; message?: string; msg?: string; data?: { prompt: string } }> {
  const resp = await apiClient.post("/ai/prompts/build-for-component-analysis", payload);
  return resp.data;
}

/** 获取组件提示词模板 content（供 AI 设置页展示/编辑） */
export async function getPromptTemplate(params: {
  serviceName?: string;
  pageId?: string;
  componentType: string;
  scenario?: string;
  locale?: string;
}): Promise<{ code: number; message?: string; data?: { content: unknown } }> {
  const resp = await apiClient.get("/ai/prompts/template", { params });
  return resp.data;
}

/** 保存组件提示词模板 content */
export async function savePromptTemplate(params: {
  serviceName?: string;
  pageId?: string;
  componentType: string;
  scenario?: string;
  locale?: string;
  content: unknown;
}): Promise<{ code: number; message?: string; data?: { templateId: string } }> {
  const resp = await apiClient.post("/ai/prompts/save-template", params);
  return resp.data;
}

